
import React, { useEffect, useState } from 'react';
import H4 from '../../../components/Typography/H4';
import { useFetchApi } from '../../../hooks/useFetchApi';
import { captialCase } from '../../../helper';
import Loader from '../../../components/Loader';
import { use } from 'i18next';

const MetricsToAccountingTerms = () => {
    const [metrics, setMetrics] = useState<Array<any>>([]);
    const [equations, setEquations] = useState<Array<any>>([]);
    
    const {
        execute: getMetrics,
        loading: mLoading,
        response: m,
      } = useFetchApi("/api/metrics", {}, "GET");
      const {
        execute: getEquations,
        loading: eLoading,
        response: e,
      } = useFetchApi("/api/equations", {}, "GET");

      useEffect(() => {
        getMetrics();
        getEquations();
      }, []);

      useEffect(() => {
        if (e && !eLoading) {
          setEquations(e);
        }
      }, [e, eLoading]);
      
      useEffect(() => {
        if ( m && !mLoading) {
            console.log("m", m  );
          setMetrics([...m.map((e: any) => ({name: e}))]);
        }
      }, [m, mLoading]);

      useEffect(() => {
        console.log("metrics", metrics);
      }, [metrics])

    return !metrics.length && !equations.length ? <Loader show />:(
        <div className="flex w-full pt-8"> 
            <div className="flex py-4 flex-col overflow-scroll">
                <H4 >Equations:</H4>
                <ul>
                    {equations.map((equation: any) => (
                        <li key={equation.name}>{equation.name}</li>
                    ))}
                </ul>

                <H4 className='mt-4'>Metrics:</H4>
                <ul>
                    {metrics.map((metric: any) => (
                        <li key={metric.name}>{captialCase(metric.name)}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default MetricsToAccountingTerms;
